import { render } from "./HeroiconsSolidCash.vue?vue&type=template&id=52f14d10"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCash.vue"]])

export default __exports__